<template>
    <div :class="['page about',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <div style="position: relative;">
                <p class="ta-c" :style="{ margin: '20px 0px 20px 0px', color: infoFontColor }">Please complete the following</p>
                <p :style="{ margin:'20px 0px 3px 30px', color: infoFontColor  }">Name</p>
                <input class="i-name" placeholder="Your Name" v-model="name" style="width:calc(100% - 80px);margin:0px 0px 0px 30px;padding:10px 10px" />
                <p :style="{ margin:'15px 0px 3px 30px', color: infoFontColor  }">Mobile</p>
                <input placeholder="Mobile Number" type="tel" v-model="mobile" style="width:calc(100% - 80px);margin:0px 0px 0px 30px;padding:10px 10px" />
                <p :style="{ margin:'15px 0px 3px 30px', color: infoFontColor  }">Email</p>
                <input placeholder="Email Address" v-model="email" autocapitalize="off" autocomplete="off" autocorrect="off" type="text" style="width:calc(100% - 80px);margin:0px 0px 20px 30px;padding:10px 10px" />
                <p class="btn" @click="join" :style="{ backgroundColor: btnColor, color: btnFontColor }">NEXT</p>
            </div>
        </div>  
    </div>
   
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import Alert from '@/utils/Alert.js';

export default {
    name: 'copper-detail',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    computed: {
        copper () { return this.$store.state.copper },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        infoFontColor () { return this.$store.state.infoFontColor },
        memberShipPrice () { return this.$store.state.memberShipPrice }
    },
    data () {
        return {
            name: '',
            email: '',
            mobile: '',
            _id: ''
        }
    },
    methods: {
        join () {
            if ( !this.mobile || isNaN(this.mobile) ) return Alert.message('Please provide a valid mobile number');
            this.setValue({ k: 'name', v: this.name });
            this.setValue({ k: 'phone', v: this.mobile });
            this.setValue({ k: 'email', v: this.email });
            this.setValue({
                k: 'copper',
                v: {
                    name: this.name,
                    phone: this.mobile,
                    email: this.email,
                    _id: this._id,
                    amount: this.memberShipPrice
                }
            });
            this.pushPage('pay');
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    },

    
}

</script>

<style lang="scss">

</style>